import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'
const prefix = localDev ? '' : requestPrefix.projectUrl
export default {
  /**
     * 新增车辆
     * @param data
     */
  save(data) {
    return Axios({
      url: prefix + '/projectCar/save',
      method: 'post',
      data: data
    })
  },
  /**
     * 更新
     * @param data
     */
  update(data) {
    return Axios({
      url: prefix + '/projectCar/update',
      method: 'post',
      data: data
    })
  },
  /**
     * 分页查询列表
     * @param data
     */
  page(data) {
    return Axios({
      url: prefix + '/projectCar/page',
      method: 'get',
      params: data
    })
  },
  /**
     * 删除
     * @param data
     */
  remove(data) {
    return Axios({
      url: prefix + '/projectCar/remove',
      method: 'get',
      params: data
    })
  },
  carType: [
    { label: '载货汽车', value: '1' },
    { label: '轿车', value: '2' },
    { label: '客车', value: '3' },
    { label: '越野汽车', value: '4' },
    { label: '牵引车', value: '5' },
    { label: '专用汽车', value: '6' },
    { label: '自卸汽车', value: '7' },
    { label: '半挂车', value: '8' },
    { label: '其他', value: '9' }
  ]
}



// WEBPACK FOOTER //
// ./src/api/manage/car-record.js